<script>
    import {addDays, format, isBefore, isSameDay, isValid, setHours, parseISO} from 'date-fns';

    export let periodFrom;
    export let periodTo;

    const from = parseISO(periodFrom);
    const to = parseISO(periodTo);

    let fromFormat = 'dd LLLL';
    let toFormat = 'dd LLLL yyyy';

    const goodMorning = setHours(addDays(from, 1), 9);
    if(isSameDay(from, to) || (isSameDay(goodMorning, to) && isBefore(to, goodMorning) )) {
      toFormat = '';
    }

    const fromFormatted = isValid(from) ? format(from, fromFormat) : '';
    const toFormatted = isValid(to) && toFormat ? format(to, toFormat) : '';
</script>

{ fromFormatted } {#if toFormatted} - {/if} {toFormatted}